import * as XLSX from 'xlsx';

export function exportToExcel(containerData, headers, source) {
    const formatedExcelDate = JSON.parse(JSON.stringify(containerData));
    formatedExcelDate.map((obj, index) => {
      delete obj.id; 
      for(const key in obj){    
        if(key.includes('ID') || key.includes('List')){
          delete obj[key]
        }      
        if(source == 'Team' && Array.isArray(obj[key])){
          obj[key] = obj[key].join(', ')
        }
        if(source == 'Member'){
          delete obj['isAdmin']
          delete obj['status']
          if(key == 'teamsMember'){
            obj['Team Details'] = obj['Teams']
            obj['Teams'] = obj[key].join(', ')
            delete obj[key]
          }
        }
        if(source == 'Product'){
          delete obj['teamId']
        }
        headers.map((head) => {
          if(head.tableKey == key){
            obj[head.title] = obj[key];
            delete obj[key]
          }
        })  
      }
      return {
        id : index + 1,
        ...obj
      }
    })
    const ws = XLSX.utils.json_to_sheet(formatedExcelDate);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, source);
    XLSX.writeFile(wb, source+'.xlsx');
}